import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CommunicationConfigService, ConfigService } from '@argalis-apps/angular-global';
import { MFormation } from '@argalis-apps/models';

@Injectable({
  providedIn: 'root'
})
export class FormOptionService {
  constructor(
    private http: HttpClient,
    private communicationConfigService: CommunicationConfigService,
    private configService: ConfigService
  ) {}

  getOptionInfo(idProduit: number): Observable<MFormation.IOptionInfo> {
    return this.http.get<MFormation.IOptionInfo>(
      `${this.communicationConfigService.getApiUri()}/formation/produit/${idProduit}/option`
    );
  }

  postOptionInfo(
    idProduit: number,
    idClient: number,
    optionUpdate?: MFormation.IOptionInfo
  ): Observable<{ success: boolean }> {
    if (optionUpdate) {
      if (optionUpdate.options.length > 0) {
        if (this.configService.getOptions().useTestData) {
          return of({ success: true });
        } else {
          return this.http.post<{ success: boolean }>(
            `${this.communicationConfigService.getApiUri()}/formation/produit/${idProduit}/client/${idClient}/option`,
            optionUpdate
          );
        }
      } else {
        return of({ success: true });
      }
    } else {
      return of({ success: true });
    }
  }
}
